export const NM_COLOR_SCHEME_STORAGE_KEY = "nm-color-scheme";
export const NM_THEME_RESOLVED_EVENT = "nm-theme-resolved-change";
export const NM_COLOR_SCHEME_VALUES = ["system", "light", "dark", "black"];

export function readStoredColorScheme() {
  if (typeof window === "undefined") return "light";
  try {
    const v = localStorage.getItem(NM_COLOR_SCHEME_STORAGE_KEY);
    if (v === "white") return "light";
    if (NM_COLOR_SCHEME_VALUES.includes(v)) return v;
  } catch (_) {}
  return "light";
}
export function getSystemPrefersDark() {
  return typeof window !== "undefined" && window.matchMedia("(prefers-color-scheme: dark)").matches;
}
export function resolveToResolvedTheme(colorScheme, systemIsDark) {
  if (colorScheme === "white") return "light";
  if (colorScheme === "black") return "dark";
  if (colorScheme === "system") return systemIsDark ? "dark" : "light";
  return colorScheme;
}
export function colorSchemeFlatSurface(colorScheme) {
  if (colorScheme === "white") return "white";
  if (colorScheme === "black") return "black";
  return null;
}
export function getResolvedThemeFromEnvironment() {
  return resolveToResolvedTheme(readStoredColorScheme(), getSystemPrefersDark());
}
export function broadcastResolvedTheme(resolvedTheme) {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(new CustomEvent(NM_THEME_RESOLVED_EVENT, {
      detail: {
        resolvedTheme
      }
    }));
  } catch (_) {}
}
export function subscribeResolvedTheme(callback) {
  if (typeof window === "undefined") return () => {};
  const onCustom = e => {
    const r = e?.detail?.resolvedTheme;
    if (r === "light" || r === "dark") callback(r);
  };
  const onStorage = ev => {
    if (ev.key === NM_COLOR_SCHEME_STORAGE_KEY || ev.key === null) {
      callback(getResolvedThemeFromEnvironment());
    }
  };
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  const onMq = () => callback(getResolvedThemeFromEnvironment());
  window.addEventListener(NM_THEME_RESOLVED_EVENT, onCustom);
  window.addEventListener("storage", onStorage);
  mq.addEventListener("change", onMq);
  return () => {
    window.removeEventListener(NM_THEME_RESOLVED_EVENT, onCustom);
    window.removeEventListener("storage", onStorage);
    mq.removeEventListener("change", onMq);
  };
}
